import styles from "./Baloon.module.css";
import { useSpeechSynthesis } from 'react-speech-kit';


export default function Baloon(props){
    const { speak, speaking, voices } = useSpeechSynthesis();

  let classes = styles.baloon;

  classes += " " + styles[props.align]
  const voice = voices.find(({ lang }) => lang.startsWith("es"));

  function sayMsg(){
    if (!speaking){
      if (!props.file)
        speak({text: props.text, voice: voice})
      else {
        var audio = new Audio(process.env.PUBLIC_URL + '/audios/' + props.file);
        audio.play();

      }
    }
  }

  return(<div className={classes}>
    {
      props.voice?

      <div className={styles.btn} onClick={sayMsg}>
        <i class="fa fa-play" aria-hidden="true"></i>
      </div>:
      <p dangerouslySetInnerHTML={{__html: props.text}}></p>
    }

  </div>)

}
